import { rest } from '@0xtorch/core'
import { z } from 'zod'
import type { TransactionDetail } from '../schemas/transactionDetail'
import { transactionDetailSchema } from '../schemas/transactionDetail'
import type { ClientCallParameters } from './create'

/** {@link https://solana.com/docs/rpc/http/gettransaction} */
const schema = z.object({
  jsonrpc: z.literal('2.0'),
  result: transactionDetailSchema.nullable().optional(),
  id: z.number(),
})

type GetTransactionParameters = ClientCallParameters & {
  readonly signature: string
}
// TODO error が出た場合にはエラーを記録できるようにする
export const getTransaction = async ({
  endpoint,
  headers,
  signature,
}: GetTransactionParameters): Promise<TransactionDetail | undefined> => {
  const response = await rest(endpoint, {
    fetchOptions: {
      method: 'POST',
      headers: {
        ...headers,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        jsonrpc: '2.0',
        id: 1,
        method: 'getTransaction',
        params: [
          signature,
          {
            maxSupportedTransactionVersion: 0,
            encoding: 'jsonParsed',
          },
        ],
      }),
    },
    schema,
  })

  if (
    response.result === null ||
    response.result === undefined ||
    response.result.blockTime === null
  ) {
    return undefined
  }
  return {
    ...response.result,
    blockTime: response.result.blockTime,
  }
}
